import { useGate } from 'effector-react'
import { ListBankCards } from '~/features/Balance/ListBankCards'
import { balanceModel, withdrawalModel } from '~/entities/Balance'
import { backFx } from '~/shared/lib/history'
import { PageContainer } from '~/shared/ui/PageContainer'
import { myPalette } from '~/shared/ui/theme'
import { useRefreshPage } from './useRefreshPage'

export function ListBankCardsPage() {
  useGate(balanceModel.Gate)
  const { refreshPage } = useRefreshPage()

  const handleOnBack = () => {
    backFx()
    withdrawalModel.openWithdrawalDrawer()
  }
  return (
    <PageContainer
      canBack
      onBack={handleOnBack}
      title='Список банковских карт'
      onRefreshPage={refreshPage}
      topContent={
        <div
          style={{
            color: myPalette.aliceBlue.main,
            fontSize: 22,
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          Выберите карту
        </div>
      }
    >
      <ListBankCards />
    </PageContainer>
  )
}
